import React from 'react'

const SiderbarHeading = ({isConnected}) => {
  return (
    <>
    <div className="sidebar-header">
          <div className={`sidebar-logo-icon ${isConnected && 'sidebar-logo-icon-connected'} `}>𝛌</div>
          <div>
          <div className={`sidebar-title`}>Hawk-Eye</div>
            <div className="sidebar-subtitle">Real-time Dashboard</div>
          </div>
        </div>
    </>
  )
}

export default SiderbarHeading